import { ArrowRight } from 'lucide-react';
import type { Language } from '../i18n';
import { flowmateCopy, formatFlowmateBudget } from '../studio-flowmate-copy';
import { CurrencyNote } from './ProjectMoney';

export function FlowMatePricing({ language, compact = false }: { language: Language; compact?: boolean }) {
  const c = flowmateCopy[language];
  const amounts = <dl className="studio-fm-price__amounts">{(['setup', 'monthly'] as const).map((period) => <div key={period}><dt>{c[period]}</dt><dd><span>{c.from}</span><strong>{formatFlowmateBudget(language, 'PLN', period)}</strong><small>{c.gross}{period === 'monthly' ? ` ${c.perMonth}` : ''}</small>{language === 'en' && <small className="studio-fm-price__usd">≈ {formatFlowmateBudget(language, 'USD', period)}{period === 'monthly' ? ` ${c.perMonth}` : ''}</small>}</dd></div>)}</dl>;
  if (compact) return <div className="studio-fm-price studio-fm-price--compact" aria-label={c.priceLabel}>{amounts}<p>{c.compactNote}</p><CurrencyNote language={language} /></div>;
  return <section className="studio-fm-price-section" id="flowmate-budget">
    <div className="studio-wrap studio-fm-price">
      <div className="studio-fm-price__intro">
        <span className="studio-kicker">{c.priceLabel}</span><h2>{c.priceTitle}</h2><p>{c.scope}</p>
        <a className="studio-text-link" href="#contact">{c.action}<ArrowRight size={18} /></a>
      </div>
      <div>{amounts}<p className="studio-fm-price__note">{c.note}</p><CurrencyNote language={language} /></div>
      <div className="studio-fm-price__details">
        {(['setup', 'monthly'] as const).map((period) => <div key={period}>
          <h3>{c[period]}</h3>
          <ul>{(period === 'setup' ? c.setupIncludes : c.monthlyIncludes).map((item) => <li key={item}>{item}</li>)}</ul>
        </div>)}
      </div>
      <details className="studio-fm-price__limits"><summary>{c.limitsTitle}</summary><p>{c.usageDetails}</p><p>{c.overage}</p></details>
      <div className="studio-fm-price__extras"><h3>{c.extrasTitle}</h3><p>{c.extras}</p></div>
    </div>
  </section>;
}
